import React from 'react'
import { RiCopyrightLine } from "react-icons/ri";

const Footer = () => {
  return (
    <footer className="footer">
    <div className="container-fluid">
        <div className="row">
            <div className="col-12">
                <div className="allrights">
                    AAAPVER Todos los derechos reservados <RiCopyrightLine />
                </div>
            </div>
        </div>
    </div>
</footer>
  )
}

export default Footer